import { render, staticRenderFns } from "./TopUpMethod.vue?vue&type=template&id=208ee27a"
import script from "./TopUpMethod.vue?vue&type=script&lang=js"
export * from "./TopUpMethod.vue?vue&type=script&lang=js"
import style0 from "./TopUpMethod.vue?vue&type=style&index=0&id=208ee27a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports